var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "_flexcol _gap-3" },
      [
        _c("base-title", { attrs: { as: "h2", level: "h2" } }, [
          _vm._v(
            _vm._s(
              _vm.Resources.BackerCenter.SectionRecentlyViewedProjectsHeader
            )
          ),
        ]),
        _vm._v(" "),
        _vm.isProcessing
          ? _c("backer-center-recently-viewed-projects-skeleton")
          : _vm.hasProjects
          ? [
              _c(
                "div",
                { staticClass: "_grid _grid-cols-3 _gap-2 _gap-3--m" },
                _vm._l(_vm.mappedProjects, function (project) {
                  return _c(
                    "a",
                    {
                      key: project.projectID,
                      attrs: {
                        href: project.projectUrl,
                        "data-qa": project.dataQa,
                      },
                    },
                    [
                      _c("base-image", {
                        staticClass: "_rounded--common _bxsh--base",
                        attrs: {
                          src: project.imageUrl,
                          alt: project.name,
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          : _c(
              "box",
              [
                _c(
                  "empty-state",
                  {
                    staticClass: "gfu-box__content",
                    attrs: { "show-divider": false, "data-qa": "empty-state" },
                  },
                  [
                    _c("base-text", { attrs: { level: "b2" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.Resources.BackerCenter
                            .RecentlyViewedProjectsEmptyStateHeader
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("base-text", { attrs: { level: "b2" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.Resources.BackerCenter
                            .RecentlyViewedProjectsEmptyStateParagraph
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "icon-base-button",
                      {
                        staticClass:
                          "gfu-btn gfu-btn--accent gfu-btn--soft _ttl _mt-3",
                        attrs: {
                          tag: "a",
                          icon: "search",
                          href: _vm.searchUrl,
                          "data-qa":
                            "recently-viewed-project:ExploreProjectsButton",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.Resources.BackerCenter
                                .UpdatesFeedEmptyStateButtonLabel
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }